import { render, staticRenderFns } from "./PayableInstitute.vue?vue&type=template&id=ab22e4e0&scoped=true&"
import script from "./PayableInstitute.vue?vue&type=script&lang=js&"
export * from "./PayableInstitute.vue?vue&type=script&lang=js&"
import style0 from "./PayableInstitute.vue?vue&type=style&index=0&id=ab22e4e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab22e4e0",
  null
  
)

export default component.exports